import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class AdminPartingField extends ShadowDOMElement {
    static className = "AdminPartingField";
    
    static properties = {
		title: {type: String, attribute: "title"},
		textLabel : {title: String, attribute: "text-label"}
    };

    constructor() {
        super();
		this.title = "Administrateur";
		this.textLabel = "Administrateur partant *";
    }

    render() {
        return html`
			<subtitle-field label="${this.title}"></subtitle-field>
            <row-with-tooltip tooltip-text="Si personne physique, indiquer la civilité (M./Mme/Melle), le prénom et le nom. Si société, indiquer la dénomination sociale.">
                <text-field label="${this.textLabel}" required name="admin_parting"></text-field>
            </row-with-tooltip>
        `;
    }
	
	isTransient (){
		return false;
	}
}

customElements.define("admin-parting-field", AdminPartingField);
